import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import Wrapper from 'common/navigation/wrapper';
import MainMenu from 'common/navigation/containers/main-menu-container';
import TicketWorklistContainer from './list/ticket-worklist-container';

const TicketListRoutes = ({ intl }) => {
  /**
   * Render menu
   * @param actionButtons
   */
  const renderMenu = actionButtons =>
    <MainMenu
      type='tickets'
      actionButtons={actionButtons}
    />;


  return (
    <Wrapper title={intl.formatMessage({ id: 'common.titles.TICKETS' })}>
      <TicketWorklistContainer renderMenu={renderMenu} isMainTicketPage={true} />
    </Wrapper>
  );
};

TicketListRoutes.propTypes = {
  intl: PropTypes.object,
};

export default injectIntl(TicketListRoutes);
